import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {POPGameClientWrapper} from '@gongxigames/framework/integrations/pop/POPGameClientWrapper';
import {UCIPInterface} from '@gongxigames/framework/integrations/pop-ucip/UCIPInterface';
import {Balance} from '@gongxigames/framework/integrations/pop-ucip/types';
import {RubyPlayGameClientWrapperSettings} from '@gongxigames/framework/integrations/rubyplay/RubyPlayGameClientWrapperSettings';

export class POPUcipGameClientWrapper extends POPGameClientWrapper {
    public static NAME = 'ucip';

    private _ucipInterface!: UCIPInterface;

    protected initParameters(): void {
        super.initParameters();

        this._ucipInterface = new UCIPInterface(this, this._eventManager, this._browser);
    }

    public init(): void {
        this._ucipInterface.completeHandshake(super.init.bind(this));
    }

    public getCurrentBet(currentBetIndex: number): string {
        const bet = this.getBets()[currentBetIndex];
        const {wager} = this.getSession().getTotalBet();

        return this.formatNumberIntoNeededFormat(bet * wager);
    }

    public getBalanceUpdateAfterRefresh(): Balance {
        const balance = this.getSession().getPlayer().getBalance();
        const value = this.formatNumberIntoNeededFormat(balance);
        const winAmount = this.formatNumberIntoNeededFormat(0);

        return {balance: {value, winAmount}};
    }

    public getBalanceData(balance: number, win = 0): Balance {
        const value = this.formatNumberIntoNeededFormat(balance);
        const winAmount = this.formatNumberIntoNeededFormat(win);

        return {balance: {value, winAmount}};
    }

    public isNextActionSpin(): boolean {
        return this.getSession().nextAction() === Action.SPIN;
    }

    protected formatNumberIntoNeededFormat(value: number): string {
        const {fractionSize} = this.currencyFormatter;

        return (value / fractionSize).toFixed(fractionSize.toString().length - 1);
    }

    protected redirectToHistoryUrl(): void {
        if (this._ucipInterface.isDelegateOpening('history')) {
            this._ucipInterface.sendOpenPageCommand('history', this.getSettings<RubyPlayGameClientWrapperSettings>().get('historyUrl'));
        } else {
            super.redirectToHistoryUrl();
        }
    }

    protected redirectToCashier(): void {
        if (this._ucipInterface.isDelegateOpening('cashier')) {
            this._ucipInterface.sendOpenPageCommand('cashier', this.getSettings<RubyPlayGameClientWrapperSettings>().get('cashierUrl'));
        } else {
            super.redirectToCashier();
        }
    }

    protected reload(): void {
        this._ucipInterface.sendCloseGameFrameCommand();
    }

    protected redirectToHomeUrl(): void {
        const homeUrl = this.getSettings<RubyPlayGameClientWrapperSettings>().get('homeUrl')!;

        if (homeUrl !== '') {
            this._ucipInterface.sendCloseGameFrameCommand();
        }
    }

    protected redirectToLogout(): void {
        this._ucipInterface.sendCloseGameFrameCommand();
    }
}
